<template>
  <form id="mainForm" action="#" method="post">
    <Card>
      <template #title>
        <Toolbar>
          <template #left>
            <div class="p-card-title">
              {{ this.workNumber }}
            </div>
            <div
              style="margin-left: 10px"
              v-if="mode != this.$FORM_MODE_CREATE"
            >
              <Button
                type="button"
                icon="pi pi-info"
                @click="toggle"
                aria:haspopup="true"
                aria-controls="overlay_panel"
                class="p-button-rounded p-button-outlined p-button-sm"
              />

              <OverlayPanel
                ref="op"
                appendTo="body"
                :showCloseIcon="true"
                id="overlay_panel"
                style="width: 550px"
                :breakpoints="{ '960px': '80vw' }"
              >
                <div class="grid field">
                  <div class="row">
                    <i class="pi pi-plus-circle" />
                    {{ this.$formatDateTime(header.CreatedAt) }}
                  </div>
                  <div class="row">&nbsp;by {{ header.CreatedBy }}</div>
                </div>
                <div class="grid field" v-if="header.EditedAt">
                  <div class="row">
                    <i class="pi pi-pencil" />
                    {{ this.$formatDateTime(header.EditedAt) }}
                  </div>
                  <div class="row">&nbsp;by {{ header.EditedBy }}</div>
                </div>
              </OverlayPanel>
            </div>
          </template>

          <template #right>
            <Button
              icon="pi pi-chevron-left"
              :label="$t('back')"
              class="p-button mr-2"
              @click="backToIndex"
            />
            <QRCode
              :refNumber="this.workNumber"
              :section="'WORK'"
              :refId="this.id"
            />
            <Button
              icon="pi pi-save"
              :label="$t('save')"
              class="p-button-success mr-2"
              @click="confirm($event)"
              v-if="
                (this.workUser == this.userName &&
                  this.statuswork == this.$STATUS_WORK.OPN &&
                  this.mode == this.$FORM_MODE_VIEW &&
                  header.IsDeleted == 'N') ||
                (this.workUser == this.userName &&
                  this.statuswork == this.$STATUS_WORK.DRF &&
                  this.mode != this.$FORM_MODE_DELETE &&
                  header.IsDeleted == 'N')
              "
            />
            <Button
              icon="pi pi-trash"
              label="Delete"
              class="p-button-danger mr-2"
              @click="confirm($event)"
              v-if="mode == this.$FORM_MODE_DELETE"
            />

            <ChangeHistoryTrans
              :data="this.workNumber"
              :type="'Work'"
              @close="onModalClose"
              @message="sidebarMessage($event)"
            />

            <ConfirmPopup></ConfirmPopup>
          </template>
        </Toolbar>
      </template>
      <template #content>
        <div class="p-inputtext-sm p-fluid">
          <div class="grid">
            <div class="col-6">
              <FormField
                :labelName="$t('mtc_order')"
                fieldName="Mo"
                v-model="header"
                fieldClass="col-6"
                labelClass="col-4"
              >
                <InputText
                  name="Mo"
                  v-model="header.Mo"
                  type="text"
                  v-if="header"
                  :disabled="!canEdit"
                />
              </FormField>
              <FormField
                :labelName="$t('requition_number')"
                fieldName="Spr"
                v-model="header"
                fieldClass="col-6"
                labelClass="col-4"
              >
                <InputText
                  name="Spr"
                  v-model="header.Spr"
                  type="text"
                  v-if="header"
                  :disabled="!canEdit"
                />
              </FormField>
              <FormField
                :labelName="$t('purchase_order')"
                fieldName="Spo"
                v-model="header"
                fieldClass="col-6"
                labelClass="col-4"
              >
                <InputText
                  name="Spo"
                  v-model="header.Spo"
                  type="text"
                  v-if="header"
                  :disabled="!canEdit"
                />
              </FormField>
              <FormField
                :labelName="$t('start_date')"
                fieldName="DateOpen"
                v-model="header"
                fieldClass="col-6"
                labelClass="col-4"
                :required="true"
              >
                <div class="field grid" style="margin-bottom: 0 !important">
                  <div class="col-5">
                    <DatePicker
                      v-model="header.DateOpen"
                      dateFormat="dd/mm/yyyy"
                      inputMask="99/99/9999"
                      momentFormat="DD/MM/YYYY"
                      class="p-inputtext-sm"
                      v-if="header"
                      :disabled="!canEdit"
                    />
                  </div>
                  <label for="DateClose" class="col-2">End</label>
                  <div class="col-5">
                    <DatePicker
                      v-model="header.DateClose"
                      dateFormat="dd/mm/yyyy"
                      inputMask="99/99/9999"
                      momentFormat="DD/MM/YYYY"
                      class="p-inputtext-sm"
                      v-if="header"
                      :disabled="
                        (this.statuswork != this.$STATUS_WORK.OPN &&
                          this.mode != this.$FORM_MODE_VIEW) ||
                        this.statuswork != this.$STATUS_WORK.OPN ||
                        this.mode == this.$FORM_MODE_DELETE
                      "
                    />
                  </div>
                </div>
              </FormField>
              <FormField
                :labelName="$t('work_area')"
                fieldName="AreaId"
                v-model="header"
                labelClass="col-4"
                fieldClass="col-6 md-6"
                :required="true"
              >
                <CustomSelect
                  v-model="header.AreaId"
                  v-if="header"
                  :url="this.$API_URL + 'list/department'"
                  :minLength="0"
                  :filter="true"
                  :params="{ companyCode: header.CompanyCode }"
                  :disabled="!canEdit"
                  @change="changeDept($event)"
                />
              </FormField>
              <FormField
                :labelName="$t('sub_area')"
                fieldName="SubArea"
                v-model="header"
                labelClass="col-4"
                fieldClass="col-6 md-6"
              >
                <CustomSelect
                  v-model="header.SubArea"
                  v-if="header"
                  :url="this.$API_URL + 'list/restrictedarea'"
                  :minLength="0"
                  :filter="true"
                  :params="{
                    deptId: header.AreaId,
                    companyCode: header.CompanyCode,
                  }"
                  :disabled="!canEdit"
                />
              </FormField>
              <FormField
                :labelName="$t('exact_place')"
                fieldName="ExactPlace"
                v-model="header"
                fieldClass="col-6"
                labelClass="col-4"
                :required="true"
              >
                <InputText
                  name="ExactPlace"
                  v-model="header.ExactPlace"
                  type="text"
                  v-if="header"
                  :disabled="!canEdit"
                />
              </FormField>
              <FormField
                :labelName="$t('work_title')"
                fieldName="Title"
                v-model="header"
                fieldClass="col-6"
                labelClass="col-4"
                :required="true"
              >
                <InputText
                  name="Title"
                  v-model="header.Title"
                  type="text"
                  v-if="header"
                  :disabled="!canEdit"
                />
              </FormField>
              <FormField
                :labelName="$t('description')"
                fieldName="Description"
                v-model="header"
                fieldClass="col-6"
                labelClass="col-4"
              >
                <InputText
                  name="Description"
                  v-model="header.Description"
                  type="text"
                  v-if="header"
                  :disabled="!canEdit"
                />
              </FormField>
              <FormField
                :labelName="$t('work_moc')"
                fieldName="Moc"
                v-model="header"
                labelClass="col-4"
                fieldClass="col-6 md-6"
              >
                <YNCheckbox
                  v-model="header.Moc"
                  :disabled="!canEdit"
                  v-if="header"
                  :binary="true"
                />
              </FormField>
              <FormField
                :labelName="$t('work_proj')"
                fieldName="Proj"
                v-model="header"
                labelClass="col-4"
                fieldClass="col-6 md-6"
              >
                <YNCheckbox
                  v-model="header.Proj"
                  :disabled="!canEdit"
                  v-if="header"
                  :binary="true"
                />
              </FormField>

              <FormField
                :labelName="$t('work_mtc')"
                fieldName="Mtc"
                v-model="header"
                labelClass="col-4"
                fieldClass="col-6 md-6"
              >
                <YNCheckbox
                  v-model="header.Mtc"
                  :disabled="!canEdit"
                  v-if="header"
                  :binary="true"
                  @change="isMtc($event)"
                />
              </FormField>
              <FormField
                :labelName="$t('work_mtctype')"
                fieldName="MtcType"
                v-model="header"
                labelClass="col-4"
                fieldClass="col-6 md-6"
                v-if="header && header.Mtc == 'Y'"
                :required="true"
              >
                <CustomSelect
                  v-model="header.MtcType"
                  v-if="header"
                  :url="this.$API_URL + 'list/mtctype_code'"
                  :minLength="0"
                  :filter="true"
                  :params="{}"
                  :disabled="!canEdit"
                />
              </FormField>

              <FormField
                :labelName="$t('img_open')"
                fieldName="ImgOpen"
                v-model="header"
                labelClass="col-4"
                fieldClass="col-6 md-6"
              >
                <CustomFileUpload
                  :fileModels="imgOpenModel"
                  :multiple="false"
                  :showUploadButton="false"
                  :showCancelButton="false"
                  :customUpload="false"
                  :maxFileSize="5000000"
                  accept="image/png,/image/jpg,image/jpeg"
                  @select="onFileSelectImgOpn"
                  :disabled="
                    mode != this.$FORM_MODE_CREATE &&
                    mode != this.$FORM_MODE_EDIT
                  "
                  @remove="onFileRemoveImgOpn"
                />
                <CustomFileUpload
                  :fileModels="this.viewFileOpens"
                  :multiple="false"
                  :showUploadButton="false"
                  :showCancelButton="false"
                  :customUpload="false"
                  @select="onFileSelectImgOpn"
                  @remove="onFileRemoveImgOpn"
                  :viewOnly="true"
                  :showHeader="false"
                  @download="onDownloadFileImgOpn"
                />
              </FormField>

              <FormField
                :labelName="$t('img_close')"
                fieldName="ImgClose"
                v-model="header"
                labelClass="col-4"
                fieldClass="col-6 md-6"
              >
                <CustomFileUpload
                  :fileModels="imgCloseModel"
                  :multiple="false"
                  :showUploadButton="false"
                  :showCancelButton="false"
                  :customUpload="false"
                  :maxFileSize="5000000"
                  accept="image/png,/image/jpg,image/jpeg"
                  @select="onFileSelectImgClose($event, header)"
                  :disabled="
                    (this.statuswork != this.$STATUS_WORK.OPN &&
                      this.mode != this.$FORM_MODE_VIEW) ||
                    this.statuswork != this.$STATUS_WORK.OPN ||
                    this.mode == this.$FORM_MODE_DELETE
                  "
                  @remove="onFileRemoveImgClose($event, header)"
                />
                <CustomFileUpload
                  :fileModels="this.viewFileCloses"
                  :multiple="false"
                  :showUploadButton="false"
                  :showCancelButton="false"
                  :customUpload="false"
                  @select="onFileSelectImgClose"
                  @remove="onFileRemoveImgClose"
                  :viewOnly="true"
                  :showHeader="false"
                  @download="onDownloadFileImgClose"
                />
              </FormField>

              <!-- <FormField :labelName="$t('closing_permit')" fieldName="WorkClosePermit" v-model="header"
                                labelClass="col-4" fieldClass="col-6 md-6">
                                <CustomFileUpload :fileModels="docClosePermitModel" :multiple="false"
                                            :showUploadButton="false" :showCancelButton="false" :customUpload="false"
                                            accept="image/png,/image/jpg" @select="onFileSelectClosePermit($event, header)"
                                            :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT || this.statuswork != this.$STATUS_WORK.OPN"
                                            @remove="onFileRemoveClosePermit($event, header)" />
                                 <CustomFileUpload :fileModels="this.viewFileClosePermits" :multiple="false"
                                    :showUploadButton="false" :showCancelButton="false" :customUpload="false"
                                    @select="onFileSelectClosePermit" @remove="onFileRemoveClosePermit" :viewOnly="true"
                                    :showHeader="false" @download="onDownloadFile" />                                            
                            </FormField> -->
            </div>
            <div class="col-6">
              <FormField
                :labelName="$t('work_no')"
                fieldName="WorkNumber"
                v-model="header"
                v-if="!isCreate"
                fieldClass="col-6"
                labelClass="col-4"
              >
                <InputText
                  name="WorkNumber"
                  v-model="header.WorkNumber"
                  type="text"
                  v-if="header"
                  :disabled="true"
                />
              </FormField>
              <FormField
                :labelName="$t('jsea_no')"
                fieldName="Jsea"
                v-model="header"
                v-if="!isCreate"
                fieldClass="col-6"
                labelClass="col-4"
              >
                <InputText
                  name="Jsea"
                  v-model="header.Jsea"
                  type="text"
                  v-if="header"
                  :disabled="true"
                />
              </FormField>
              <FormField
                :labelName="$t('status')"
                fieldName="Status"
                v-model="header"
                v-if="!isCreate"
                fieldClass="col-6"
                labelClass="col-4"
              >
                <InputText
                  name="Jsea"
                  v-model="header.Status"
                  type="text"
                  v-if="header"
                  :disabled="true"
                />
              </FormField>
              <FormField
                :labelName="$t('created_by')"
                fieldName="CreatedBy"
                v-model="header"
                v-if="!isCreate"
                fieldClass="col-6"
                labelClass="col-4"
              >
                <InputText
                  name="CreatedBy"
                  v-model="header.CreatedBy"
                  type="text"
                  v-if="header"
                  :disabled="true"
                />
              </FormField>
              <FormField
                :labelName="$t('work_vendor')"
                fieldName="VendorCode"
                v-model="header"
                v-if="!isCreate"
                fieldClass="col-6"
                labelClass="col-4"
              >
                <InputText
                  name="VendorCode"
                  v-model="header.VendorCode"
                  type="text"
                  v-if="header"
                  :disabled="true"
                />
              </FormField>
              <FormField
                :labelName="$t('company_owning')"
                fieldName="CompanyCode"
                v-model="header"
                v-if="!isCreate"
                fieldClass="col-6"
                labelClass="col-4"
              >
                <InputText
                  name="CompanyCode"
                  v-model="header.CompanyCode"
                  type="text"
                  v-if="header"
                  :disabled="true"
                />
              </FormField>
              <FormField
                :labelName="$t('status_area')"
                fieldName="StatusArea"
                v-model="header"
                v-if="!isCreate"
                fieldClass="col-6"
                labelClass="col-4"
              >
                <InputText
                  name="StatusArea"
                  v-model="header.StatusArea"
                  type="text"
                  v-if="header"
                  :disabled="true"
                />
              </FormField>
              <FormField
                :labelName="$t('jsea')"
                fieldName="Jsea"
                v-model="header"
                labelClass="col-4"
                fieldClass="col-6 md-6"
              >
                <CustomFileUpload
                  :fileModels="docJseaModel"
                  :multiple="false"
                  :showUploadButton="false"
                  :showCancelButton="false"
                  :customUpload="false"
                  :maxFileSize="5000000"
                  :accept="'image/png,image/jpg,image/jpeg,application/pdf'"
                  @select="onFileSelectImgJsea"
                  :disabled="
                    mode != this.$FORM_MODE_CREATE &&
                    mode != this.$FORM_MODE_EDIT
                  "
                  @remove="onFileRemoveImgJsea"
                />
                <CustomFileUpload
                  :fileModels="this.viewFileJseaHeader"
                  :multiple="false"
                  :showUploadButton="false"
                  :showCancelButton="false"
                  :customUpload="false"
                  @select="onFileSelectImgJsea"
                  @remove="onFileRemoveImgJsea"
                  :viewOnly="true"
                  :showHeader="false"
                  @download="onDownloadFileJsea"
                />
              </FormField>
              <FormField
                :labelName="$t('jsea_title')"
                fieldName="JseaTitle"
                v-model="header"
                fieldClass="col-6"
                labelClass="col-4"
                v-if="this.docJseaModel.length > 0"
                :required="true"
              >
                <InputText
                  name="JseaTitle"
                  :class="{ 'p-invalid': submitted && !header.JseaTitle }"
                  v-model="header.JseaTitle"
                  type="text"
                  v-if="header"
                  :disabled="!canEdit"
                />
                <small
                  v-if="
                    header &&
                    !header.JseaTitle &&
                    submitted &&
                    mode != this.$FORM_MODE_DELETE
                  "
                  class="p-error"
                  >{{ $t("is_required").replace("Value", $t("jsea_title")) }}
                </small>
              </FormField>
              <FormField
                :labelName="$t('jsea_description')"
                fieldName="JseaDescription"
                v-model="header"
                fieldClass="col-6"
                labelClass="col-4"
                v-if="this.docJseaModel.length > 0"
                :required="true"
              >
                <InputText
                  name="JseaDescription"
                  :class="{ 'p-invalid': submitted && !header.JseaDescription }"
                  v-model="header.JseaDescription"
                  type="text"
                  v-if="header"
                  :disabled="!canEdit"
                />
                <small
                  v-if="
                    header &&
                    !header.JseaDescription &&
                    submitted &&
                    mode != this.$FORM_MODE_DELETE
                  "
                  class="p-error"
                  >{{
                    $t("is_required").replace("Value", $t("jsea_description"))
                  }}
                </small>
              </FormField>
            </div>

            <div class="col-12 mt-4" v-if="this.mode != this.$FORM_MODE_CREATE">
              <TabView>
                <TabPanel :header="$t('release_approval')">
                  <ChangeHistory
                    v-if="this.header"
                    :modelValue="this.dataModelRelease"
                    :dataRequestLog="this.dataRelease"
                    :mode="this.mode"
                  ></ChangeHistory>
                </TabPanel>
                <!-- <TabPanel :header="$t('log_history')">
                  <ChangeHistory
                    v-if="this.header"
                    :modelValue="this.dataModelWorkLogs"
                    :dataRequestLog="this.dataWorkLogs"
                    :mode="this.mode"
                  ></ChangeHistory>
                </TabPanel> -->
                <TabPanel :header="$t('jsea_log')">
                  <ChangeHistory
                    v-if="this.header"
                    :modelValue="this.dataModelJseaLog"
                    :dataRequestLog="this.dataJseaLog"
                    :mode="this.mode"
                  ></ChangeHistory>
                </TabPanel>
              </TabView>
            </div>
          </div>
        </div>
      </template>
    </Card>
  </form>

  <FileViewer
    v-if="dialogVisibleView"
    :isVisible="dialogVisibleView"
    :urlFile="this.fileUrlView"
    :isPdf="this.isPdf"
    :isImg="this.isImg"
    :fileNames="this.fileName"
    :sectionFile="this.sectionFile"
    @hide="hideViewer"
  />
</template>

<script>
import moment from "moment";
import QRCode from "./_QRCode.vue";
export default {
  name: "Editor",
  components: {
    QRCode: QRCode,
  },
  data() {
    return {
      indexName: "WorkIndex",
      url: this.$API_URL + "work/",
      userTimeZoneOffset: moment().utcOffset() / 60,
      timezoneUserOffset: this.$store.getters.getTimezoneOffset,
      header: null,
      detail: null,
      mode: "",
      id: 0,
      qrData: null,
      imgOpenModel: [],
      imgCloseModel: [],
      docJseaModel: [],
      docClosePermitModel: [],
      workNumber: null,
      formEditable: true,
      companyCodeUser: this.$store.getters.getCompanyCode,
      companyIdUser: this.$store.getters.getCompanyId,
      idUser: this.$store.getters.getUserId,
      userName: this.$store.getters.getUsername,
      viewFileOpens: [],
      viewFileCloses: [],
      viewFileClosePermits: [],
      viewFileJseaHeader: [],
      statuswork: null,
      submitted: false,
      dataModel: false,
      dataModelWorkLogs: null,
      dataModelRelease: null,
      dataModelJseaLog: null,
      showInitMtc: null,
      statusWork: "",
      workUser: "",
      isMtcWork: "N",
      fileUrlView: null,
      fileUrl: null,
      fileName: null,
      fileTypeView: null,
      fileHref: null,
      sectionFile: null,
      isImg: false,
      isPdf: false,
      dialogVisibleView: false,
      // dataWorkLogs: [
      //   { field: "ActionRole", header: "Role" },
      //   { field: "ActionBy", header: "Action By" },
      //   { field: "Action_Date", header: "Action Date" },
      //   { field: "Notes", header: "Notes" },
      // ],
      dataRelease: [
        { field: "ActionRole", header: "Role" },
        { field: "ActionBy", header: "Username" },
        { field: "Fullname", header: "Fullname" },
        { field: "Category", header: "Category" },
        { field: "Level", header: "Level" },
        { field: "Status", header: "Status" },
        { field: "ApprovedBy", header: "Approved By" },
        { field: "Remark", header: "Remark" },
        { field: "UrlWA", header: "Send WA Notification" },
      ],
      dataJseaLog: [
        { field: "Ordinal", header: "Ordinal" },
        { field: "JseaNumber", header: "JseaNumber" },
        { field: "Title", header: "Title" },
        { field: "Description", header: "Description" },
        { field: "DownloadJsea", header: "Download" },
      ],
    };
  },
  methods: {
    hideRow(data) {
      return data.mode == this.$FORM_MODE_DELETE ? "row-hidden" : null;
    },
    getData() {
      var self = this;
      this.$axios
        .get(this.url + this.id + "/" + this.mode)
        .then((response) => {
          //console.log(response.data.data.header)
          self.header = response.data.data.header;
          self.dataModel = response.data.data.detail;
          self.header.mode = self.mode;
          self.statuswork = response.data.data.header.Status;
          self.workNumber = response.data.data.header.WorkNumber;
          self.qrData = response.data.data.header.QrCodeWork;
          self.statuswork = response.data.data.header.Status;
          // self.dataModelWorkLogs = response.data.data.header.WorkLogs;
          self.dataModelRelease = response.data.data.header.ApprovalLogs;
          self.dataModelJseaLog = response.data.data.header.JseaLogs;
          self.viewFileOpens = response.data.data.header.viewFilesOpen;
          self.viewFileCloses = response.data.data.header.viewFilesClose;
          self.viewFileClosePermits =
            response.data.data.header.viewFilesClosePermit;
          self.viewFileJseaHeader = response.data.data.header.viewFilesJsea;
          self.workUser = response.data.data.header.WorkUser;
        })
        .catch(function (error) {
          //console.log(error);
        });
    },
    changeDept(e) {
      if (e == null) {
        this.header.AreaId = "";
        this.header.SubArea = "";
      } else {
        this.header.AreaId = e.id;
        this.header.SubArea = "";
      }
    },
    isMtc(event) {
      if (this.header.Mtc == "N") {
        this.isMtcWork = "N";
        return false;
      } else {
        this.isMtcWork = "Y";
        return true;
      }
    },
    blockUI() {
      this.$emit("block-ui");
    },
    unblockUI() {
      this.$emit("unblock-ui");
    },
    hideViewer() {
      this.dialogVisibleView = false;
      this.fileUrl = null;
      this.fileName = null;
      this.fileTypeView = null;
      this.fileHref = null;
      this.isImg = false;
      this.isPdf = false;
    },
    saveData() {
      this.$emit("block-ui");

      this.header.JseaLogs = null;
      this.header.ApprovalLogs = null;
      this.header.Jseas = null;
      this.header.WorkLogs = null;

      var self = this;
      var data = new FormData();

      var workInput = this.header;

      data.append("Id", this.header.Id);
      data.append("mode", this.header.mode);
      data.append("TimeZoneOffset", this.timezoneUserOffset);

      if (this.header.WorkNumber != null)
        data.append("WorkNumber", this.header.WorkNumber);
      if (this.header.Jsea != null) data.append("Jsea", this.header.Jsea);
      if (this.header.Status != null) data.append("Status", this.header.Status);
      if (this.header.MtcType != null)
        data.append("Status", this.header.MtcType);
      if (this.header.Mo != null) data.append("Mo", this.header.Mo);
      if (this.header.Spr != null) data.append("Spr", this.header.Spr);
      if (this.header.Spo != null) data.append("Spo", this.header.Spo);
      if (this.header.DateOpen != null)
        data.append(
          "DateOpen",
          moment(this.header.DateOpen).format("YYYY/MM/DD").toString()
        );
      if (this.header.DateClose != null)
        data.append(
          "DateClose",
          moment(this.header.DateClose).format("YYYY/MM/DD").toString()
        );
      if (this.header.AreaId != null) data.append("AreaId", this.header.AreaId);
      if (this.header.SubArea != null)
        data.append("SubArea", this.header.SubArea);
      if (this.header.ExactPlace != null)
        data.append("ExactPlace", this.header.ExactPlace);
      if (this.header.Title != null) data.append("Title", this.header.Title);
      if (this.header.Description != null)
        data.append("Description", this.header.Description);
      if (this.header.Moc != null) data.append("Moc", this.header.Moc);
      if (this.header.Proj != null) data.append("Proj", this.header.Proj);
      if (this.header.Mtc != null) data.append("Mtc", this.header.Mtc);
      if (this.header.MtcType != null)
        data.append("MtcType", this.header.MtcType);
      if (this.header.JseaTitle != null)
        data.append("JseaTitle", this.header.JseaTitle);
      if (this.header.JseaDescription != null)
        data.append("JseaDescription", this.header.JseaDescription);
      if (this.header.ImgOpen != null)
        data.append("ImgOpen", this.header.ImgOpen);
      if (this.header.ImgClose != null)
        data.append("ImgClose", this.header.ImgClose);
      if (this.header.WorkClosePermit != null)
        data.append("WorkClosePermit", this.header.WorkClosePermit);

      if (this.imgOpenModel.length != 0) {
        for (var x = 0; x < this.imgOpenModel.length; x++) {
          data.append(
            "attachmentsopen.File",
            this.imgOpenModel[x],
            this.imgOpenModel[x].name
          );
        }
      }

      if (this.imgCloseModel.length != 0) {
        for (var x = 0; x < this.imgCloseModel.length; x++) {
          var file1 = this.imgCloseModel[x];
          data.append("attachmentsClose.File", file1, file1.name);
        }
      }

      if (this.docJseaModel.length != 0) {
        for (var x = 0; x < this.docJseaModel.length; x++) {
          var file2 = this.docJseaModel[x];
          data.append("attachmentsJsea.File", file2, file2.name);
        }
      }

      if (this.docClosePermitModel.length > 0) {
        for (var x = 0; x < this.docClosePermitModel.length; x++) {
          var file3 = this.docClosePermitModel[x];
          data.append("attachmentsClosePermit.File", file3, file3.name);
        }
      }

      this.$axios
        .post(this.url, data, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          if (response.data.success) {
            this.$router.push({
              name: this.indexName,
              params: {
                showToast: true,
                severity: "success",
                summary: "Data Saved",
                detail: response.data.message,
                life: 3000,
              },
            });
          } else {
            this.showError("Error Saving Data", response.data.message);
          }
        })
        .catch(function (error) {
          this.showError("Error Saving Data", error);
        });
    },
    showError(summary, message) {
      this.$emit("unblock-ui");
      this.$toast.add({
        severity: "error",
        summary: summary,
        detail: message,
        life: 3000,
      });
    },
    backToIndex() {
      this.$router.push({ path: "/Work/Index" });
    },
    toggle(event) {
      this.$refs.op.toggle(event);
    },
    confirm(event) {
      this.submitted = true;
      if (this.docJseaModel.length != 0) {
        if (!this.header.JseaTitle || !this.header.JseaDescription) {
          return false;
        } else {
          this.$confirm.require({
            target: event.currentTarget,
            message: "Are you sure?",
            icon: "pi pi-exclamation-triangle",
            accept: () => {
              this.saveData();
            },
            reject: () => {
              //callback to execute when user rejects the action
            },
          });
        }
      } else {
        this.$confirm.require({
          target: event.currentTarget,
          message: "Are you sure?",
          icon: "pi pi-exclamation-triangle",
          accept: () => {
            this.saveData();
          },
          reject: () => {
            //callback to execute when user rejects the action
          },
        });
      }
    },
    addDetail() {
      var newDetail = this.dataModel;
      newDetail.mode = this.$FORM_MODE_CREATE;
      var det = { ...newDetail };

      this.header.Details.push(det);
    },
    deleteDetail(event) {
      if (event) {
        var detail = this.header.Details[event.index];

        if (detail.mode == this.$FORM_MODE_CREATE)
          this.header.Details.splice(this.header.Details.indexOf(detail), 1);
        else detail.mode = this.$FORM_MODE_DELETE;
      }
    },
    onCellEditComplete(event) {
      this.editDetail(event.index);
    },
    onFileSelectImgJsea(event, header) {
      this.docJseaModel = [];
      for (var i = 0; i < event.files.length; i++) {
        this.docJseaModel.push(event.files[i]);
      }
    },
    onFileRemoveImgJsea(files, data) {
      this.docJseaModel = [];
      for (var i = 0; i < files.length; i++) {
        this.docJseaModel.push(event.files[i]);
      }
    },
    onFileSelectImgOpn(event) {
      this.imgOpenModel = event.files;
    },
    onFileRemoveImgOpn() {
      this.imgOpenModel = [];
    },
    onFileSelectImgClose(event, header) {
      this.imgCloseModel = [];
      for (var i = 0; i < event.files.length; i++) {
        this.imgCloseModel.push(event.files[i]);
      }
    },
    onFileRemoveImgClose(files, data) {
      this.imgCloseModel = [];
      for (var i = 0; i < files.length; i++) {
        this.imgCloseModel.push(event.files[i]);
      }
    },
    onFileSelectClosePermit(event, header) {
      this.docClosePermitModel = [];
      for (var i = 0; i < event.files.length; i++) {
        this.docClosePermitModel.push(event.files[i]);
      }
    },
    onFileRemoveClosePermit(files, data) {
      this.docClosePermitModel = [];
      for (var i = 0; i < files.length; i++) {
        this.docClosePermitModel.push(event.files[i]);
      }
    },
    onFileSelectUpload(event) {
      this.detailFiles = event.files;
      this.uploadFile = true;
    },

    onDownloadFileImgOpn(file) {
      this.$emit("block-ui");
      //console.log(file)

      var self = this;
      this.$axios
        .get(
          this.url + "download_currently_img_opn/" + file.id + "/" + file.name,
          {
            responseType: "blob",
          }
        )
        .then((response) => {
          self.fileTypeView = self.getFileType(file.name);
          if (self.fileTypeView && self.fileTypeView.startsWith("image/")) {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            self.fileUrlView = url;
            self.fileName = file.name;
            self.fileUrl = url;
            self.isImg = true;
          }

          if (self.fileTypeView === "application/pdf") {
            const blob = new Blob([response.data], { type: "application/pdf" });
            self.fileUrlView = window.URL.createObjectURL(blob);
            self.fileName = file.name;
            self.isPdf = true;
          }

          self.sectionFile = "Initial image";
          self.dialogVisibleView = true;
          self.$emit("unblock-ui");
        })
        .catch(function (err) {
          self.$parent.$toast.add({
            severity: "error",
            summary: "Error",
            detail: "File not found" + err,
            life: 3000,
          });
          self.blocked = false;
          self.$emit("unblock-ui");
          //self.showAssignModal = false;
        });
    },
    onDownloadFileImgClose(file) {
      //console.log(file)
      this.$emit("block-ui");
      var self = this;
      this.$axios
        .get(
          this.url + "download_currently_img_cls/" + file.id + "/" + file.name,
          {
            responseType: "blob",
          }
        )
        .then((response) => {
          self.fileTypeView = self.getFileType(file.name);
          if (self.fileTypeView && self.fileTypeView.startsWith("image/")) {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            self.fileUrlView = url;
            self.fileName = file.name;
            self.fileUrl = url;
            self.isImg = true;
          }

          if (self.fileTypeView === "application/pdf") {
            const blob = new Blob([response.data], { type: "application/pdf" });
            self.fileUrlView = window.URL.createObjectURL(blob);
            self.fileName = file.name;
            self.isPdf = true;
          }

          self.sectionFile = "Final image";
          self.dialogVisibleView = true;
          self.$emit("unblock-ui");
        })
        .catch(function (err) {
          self.$parent.$toast.add({
            severity: "error",
            summary: "Error",
            detail: "File not found" + err,
            life: 3000,
          });
          self.blocked = false;
          self.$emit("unblock-ui");
          //self.showAssignModal = false;
        });
    },
    onDownloadFileJsea(file) {
      this.$emit("block-ui");
      //console.log(file)

      var self = this;
      this.$axios
        .get(
          this.url + "download_currently_jsea/" + file.id + "/" + file.name,
          {
            responseType: "blob",
          }
        )
        .then((response) => {
          self.fileTypeView = self.getFileType(file.name);
          if (self.fileTypeView && self.fileTypeView.startsWith("image/")) {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            self.fileUrlView = url;
            self.fileName = file.name;
            self.fileUrl = url;
            self.isImg = true;
          }

          if (self.fileTypeView === "application/pdf") {
            const blob = new Blob([response.data], { type: "application/pdf" });
            self.fileUrlView = window.URL.createObjectURL(blob);
            self.fileName = file.name;
            self.isPdf = true;
          }

          self.sectionFile = "JSEA";
          self.dialogVisibleView = true;

          self.$emit("unblock-ui");
        })
        .catch(function (err) {
          self.$parent.$toast.add({
            severity: "error",
            summary: "Error",
            detail: "File not found" + err,
            life: 3000,
          });
          self.blocked = false;
          self.$emit("unblock-ui");
          //self.showAssignModal = false;
        });
    },
    getFileType(fileName) {
      const extension = fileName.split(".").pop().toLowerCase();
      switch (extension) {
        case "pdf":
          return "application/pdf";
        case "jpg":
        case "jpeg":
          return "image/jpeg";
        case "png":
          return "image/png";
        default:
          return "application/octet-stream";
      }
    },
    editDetail(index) {
      if (this.header.Details && this.header.Details.length > 0) {
        let m = this.header.Details[index].mode;

        if (m == this.$FORM_MODE_UNCHANGED) {
          this.header.Details[index].mode = this.$FORM_MODE_EDIT;
        }
      }
    },
  },
  created() {
    this.mode = this.$route.query.mode;
    this.id = this.$route.query.id ?? 0;

    this.getData();
  },
  computed: {
    canEdit() {
      return (
        this.mode == this.$FORM_MODE_CREATE || this.mode == this.$FORM_MODE_EDIT
      );
    },
  },
};
</script>
